import { render, staticRenderFns } from "./RsaSchedaValutazioneDisartriaEditComponent.vue?vue&type=template&id=2a458027&scoped=true"
import script from "./RsaSchedaValutazioneDisartriaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaValutazioneDisartriaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaValutazioneDisartriaEditComponent.vue?vue&type=style&index=0&id=2a458027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a458027",
  null
  
)

export default component.exports